<div class="photo-preview">
  <img class="image-thumbnail" src={{photoPreviewUrl}}>
  <div class="filename">
    {{filename}}
  </div>
  @if (isAdmin) {
    <div class="actions">
      <img src="./assets/images/black-x.svg" (click)="rejectClicked.emit()">
      <img src="./assets/images/black-checkmark.svg" (click)="approveClicked.emit()">
    </div>
  }
  @if (!isAdmin) {
    <div class="actions">
      <img src="./assets/images/black-x.svg" (click)="deleteClicked.emit()">
    </div>
  }
</div>